export default __webpack_public_path__ + "static/media/icon-pass-coopeuch.05b0806d.png";